module.exports = __webpack_public_path__ + "img/bg4.99cc4ffe.png";